module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-42.019a45cd.png";